var _excluded = ["openFollowAnotherProperty"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import useFollowAnotherProperty from './use-follow-another-property';
import useFollowThisProperty from './use-follow-this-property';
import useUnfollowProperty from './use-unfollow-property';
import useUpdateNotificationSettings from './use-update-notification-settings';
import useUpdatePropertyDetails from './use-update-property-details';
import useUpdateRelationship from './use-update-relationship';
var useMyFollowedPropertyDialogs = function useMyFollowedPropertyDialogs() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    onEvent = _ref.onEvent;
  var _useFollowThisPropert = useFollowThisProperty({
      onCompleted: onEvent
    }),
    openFollowThisProperty = _useFollowThisPropert.openFollowThisProperty,
    followThisPropertyProps = _useFollowThisPropert.followThisPropertyProps;
  var _useUnfollowProperty = useUnfollowProperty({
      onCompleted: onEvent
    }),
    openUnfollowProperty = _useUnfollowProperty.openUnfollowProperty,
    unfollowProps = _useUnfollowProperty.unfollowProps;
  var _useUpdatePropertyDet = useUpdatePropertyDetails({
      onCompleted: onEvent
    }),
    openUpdatePropertyDetails = _useUpdatePropertyDet.openUpdatePropertyDetails,
    updatePropertyDetailsProps = _useUpdatePropertyDet.updatePropertyDetailsProps;
  var _useFollowAnotherProp = useFollowAnotherProperty({
      onCompleted: onEvent
    }),
    openFollowAnotherProperty = _useFollowAnotherProp.openFollowAnotherProperty,
    followAnotherPropertyProps = _objectWithoutProperties(_useFollowAnotherProp, _excluded);
  var _useUpdateNotificatio = useUpdateNotificationSettings({
      onCompleted: onEvent
    }),
    openUpdateNotificationSettings = _useUpdateNotificatio.openUpdateNotificationSettings,
    updateNotificationSettingsProps = _useUpdateNotificatio.updateNotificationSettingsProps;
  var _useUpdateRelationshi = useUpdateRelationship({
      onCompleted: onEvent
    }),
    openUpdateRelationship = _useUpdateRelationshi.openUpdateRelationship,
    updateRelationshipProps = _useUpdateRelationshi.updateRelationshipProps;
  return {
    openFollowThisProperty,
    openUnfollowProperty,
    openUpdatePropertyDetails,
    openUpdateNotificationSettings,
    openUpdateRelationship,
    openFollowAnotherProperty,
    myFollowedPropertyDialogProps: _objectSpread(_objectSpread({}, followThisPropertyProps ? {
      followThisPropertyProps
    } : followAnotherPropertyProps), {}, {
      unfollowProps,
      updatePropertyDetailsProps,
      updateNotificationSettingsProps,
      updateRelationshipProps
    })
  };
};
export default useMyFollowedPropertyDialogs;